import Box from '@classify/react-core-components/Box';
import { styled } from '@classify/react-core-components/styles';

export const ContactElement = styled(Box)(({ theme: { spacing, containerQueries, palette } }) => ({
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  gap: spacing(1),
  paddingTop: spacing(1),
  borderTop: `1px solid ${palette.divider}`,
  [containerQueries.up('sm')]: {
    width: 'auto',
    alignItems: 'center',
    padding: spacing(0, 2),
    borderTop: 'none',
    '&:first-child': {
      paddingLeft: 0,
    },
    '& + &': {
      borderLeft: `1px solid ${palette.divider}`,
    },
  },
  svg: {
    fontSize: spacing(2),
  },
}));

export const CopyWrapper = styled('div')(({ theme: { breakpoints } }) => ({
  maxWidth: 240,
  [breakpoints.up('md')]: {
    maxWidth: 'none',
  },
}));
